export default __webpack_public_path__ + "static/media/brain.63b06379.png";